<div class="procedures-items-container" *ngIf="selectedProtocolObjects?.length">
  <div class="protocol-card" *ngFor="let protocol of selectedProtocolObjects; trackBy: trackByProtocolId">
    <header class="protocol-header">
      <p class="protocol-name">{{ protocol.name }}</p>
      <span class="protocol-badge">{{ protocol.type }}</span>
    </header>

    <div class="procedures-list-wrapper">
      <div class="procedure-item" *ngFor="let procedure of protocol.procedures; trackBy: trackByProcedureId">
        <span class="procedure-name">{{ procedure.description }}</span>

        <button
          type="button"
          class="remove-button"
          [attr.aria-label]="'actions.remove-procedure' | translate"
          (click)="onRemoveProcedure(procedure.id, protocol.id)"
        >
          <span class="remove-icon">−</span>
        </button>
      </div>
    </div>
  </div>
</div>
